export default __webpack_public_path__ + "static/media/faceDraw2.7f4a9d78.svg";